import { takeLatest } from 'redux-saga/effects';
import {
    FETCH_BUNDLE_INVOICE_LIST_REQUEST,
    FETCH_BUNDLE_INVOICE_REQUEST,
} from '../../redux/modules/bundleInvoice/bundleInvoice-actions';
import {
    FETCH_ISSUE_INVOICE_LIST_REQUEST,
} from '../../redux/modules/issueInvoice/issueInvoice-actions';
import { fetchBundleInvoiceListWorkerSaga, fetchBundleInvoiceWorker, fetchIssueInvoiceListWorkerSaga } from './bundleInvoiceWorkerSaga';

export function* fetchBundleInvoice() {
    yield takeLatest(FETCH_BUNDLE_INVOICE_LIST_REQUEST, fetchBundleInvoiceListWorkerSaga);
}

export function* fetchIssueInvoices() {
    yield takeLatest(FETCH_ISSUE_INVOICE_LIST_REQUEST, fetchIssueInvoiceListWorkerSaga);
}

export function* fetchBundleInvoiceById() {
    yield takeLatest(FETCH_BUNDLE_INVOICE_REQUEST, fetchBundleInvoiceWorker);
}
